import { apiClient } from './api/client';

export type AiHealthLevel = 'operational' | 'degraded' | 'outage' | 'unknown';

export interface AiHealthStatus {
  status: AiHealthLevel;
  checkedAt: string;
  activeIncidents: { title: string; impact: string; updatedAt: string }[];
}

export const aiHealthService = {
  getStatus: (): Promise<AiHealthStatus> =>
    apiClient.get('/ai-health').then((r) => r.data),
};
